var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupOutlined(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2C6.98 2 2.5 6.48 2.5 12C2.5 17.52 6.98 22 12.5 22C18.02 22 22.5 17.52 22.5 12C22.5 6.48 18.02 2 12.5 2ZM12.5 20C8.09 20 4.5 16.41 4.5 12C4.5 7.59 8.09 4 12.5 4C16.91 4 20.5 7.59 20.5 12C20.5 16.41 16.91 20 12.5 20Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16C9.60457 16 10.5 15.1046 10.5 14C10.5 12.8954 9.60457 12 8.5 12C7.39543 12 6.5 12.8954 6.5 14C6.5 15.1046 7.39543 16 8.5 16Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10C13.6046 10 14.5 9.10457 14.5 8C14.5 6.89543 13.6046 6 12.5 6C11.3954 6 10.5 6.89543 10.5 8C10.5 9.10457 11.3954 10 12.5 10Z",
    fill: "#718096"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16C17.6046 16 18.5 15.1046 18.5 14C18.5 12.8954 17.6046 12 16.5 12C15.3954 12 14.5 12.8954 14.5 14C14.5 15.1046 15.3954 16 16.5 16Z",
    fill: "#718096"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupOutlined);
export default __webpack_public_path__ + "static/media/group-outlined.b0c0ab5240c583ebeb898e6de1ff29d8.svg";
export { ForwardRef as ReactComponent };